const CONTROLLER = '/billing';
const PATHS = {
  GET_PLANS: '/plans',
  CHECKOUT: '/checkout',
  GET_SUBSCRIPTION: '/subscription',
  CANCEL_SUBSCRIPTION: '/subscription/cancel',
  REACTIVATE_SUBSCRIPTION: '/subscription/reactivate',
  CUSTOMER_PORTAL: '/customer-portal',
  PORTAL: '/portal',
};

const BillingApiRoutes = {
  CONTROLLER,
  PATHS,
  NAMES: Object.fromEntries(
    (Object.keys(PATHS) as Array<keyof typeof PATHS>).map((k) => [k, k]),
  ) as {
    [K in keyof typeof PATHS]: K;
  },
  GET_PLANS: `${CONTROLLER}${PATHS.GET_PLANS}`,
  CHECKOUT: (planType: string) => `${CONTROLLER}${PATHS.CHECKOUT}/${planType}`,
  GET_SUBSCRIPTION: `${CONTROLLER}${PATHS.GET_SUBSCRIPTION}`,
  CANCEL_SUBSCRIPTION: `${CONTROLLER}${PATHS.CANCEL_SUBSCRIPTION}`,
  REACTIVATE_SUBSCRIPTION: `${CONTROLLER}${PATHS.REACTIVATE_SUBSCRIPTION}`,
  CUSTOMER_PORTAL: `${CONTROLLER}${PATHS.CUSTOMER_PORTAL}`,
  PORTAL: `${CONTROLLER}${PATHS.PORTAL}`,
};

export default BillingApiRoutes;
